import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import {
  Backdrop,
  CardContent,
  CircularProgress,
  Link,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "../api/auth";
import { useContext, useEffect, useState } from "react";
import { PageContext } from "../contexts/PageContext";
import { InteractionStatus } from "@azure/msal-browser";

export default function Login() {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();
  const { isLoggedIn, user } = useContext(PageContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (inProgress === InteractionStatus.None && !isAuthenticated) {
      localStorage.clear();
      instance.loginRedirect(loginRequest).catch((error) => console.log(error));
      return;
    }
    if (inProgress === InteractionStatus.None && isAuthenticated) {
      if (window.location.pathname === "/login" || window.location.pathname === "/") {
        window.location.replace("/dashboard");
      }
    }
  }, [isLoggedIn, user, instance, inProgress, isAuthenticated]);
  // if (isAuthenticated ) {
  //   navigate("/dashboard");
  //   return null;
  // }

  return (
    <>
      <Backdrop open={true} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>Authentication status: {isAuthenticated ? 'OK' : inProgress}</Typography>
        <div style={{ padding: 50 }}>
          <CircularProgress color="inherit" />
        </div>
      </Backdrop>
    </>
  );
}
